import React from "react";

const Myfavs = ({ favCharacters, setFavCharacters }) => {
  return (
    <>
      <div className="container">
        <h1>YOUR FAVORITES</h1>
      </div>
    </>
  );
};

export default Myfavs;
